<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="regsitrationTypePlace.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                  data-cy="description-input"
                />
                <small data-cy="v-description-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first valor -->
          <b-col cols="12">
            <b-form-group label="Valor" label-for="v-valor">
              <cleave
                id="v-valor"
                v-model.number="regsitrationTypePlace.valor"
                class="form-control"
                :raw="true"
                :options="options.number"
                placeholder="valor"
                data-cy="valor-input"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Tipo de Registro"
              rules=""
            >
              <b-form-group label="Tipo de Registro" label-for="v-cbo">
                <v-select
                  v-model="regsitrationTypePlace.tipo"
                  label="nome"
                  :options="comboTypes"
                  :state="errors.length > 0 ? false : null"
                  data-cy="type-select"
                  :disabled="!canEditOrInsert"
                />
                <small data-cy="v-tipo-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Categoria de Contribuição Padrão"
              label-for="v-tipo-faixa"
            >
              <v-select
                v-model="regsitrationTypePlace.tiposFaixaPadrao"
                multiple
                :get-option-label="(opt) => opt.nome || opt.descricao"
                :options="comboTipoFaixa"
                placeholder="Selecione uma categoria para automação"
                data-cy="tipo-faixa"
                :disabled="!canEditOrInsert"
              />
              <small class="text-muted"
                >Se selecionado, novas inscrições deste tipo gerarão
                mensalidades automaticamente. Caso nada pareça na lista será por
                conta de nenhuma faixa de contribuição estar configurada para
                lançar mensalidades.</small
              >
            </b-form-group>
          </b-col>

          <!-- tipo pagamento padrao -->
          <b-col cols="12">
            <b-form-group
              label="Tipo de Pagamento Padrão"
              label-for="v-tipo-pagamento"
            >
              <v-select
                v-model="regsitrationTypePlace.tipoPagamentoPadrao"
                :get-option-label="(opt) => opt.nome || opt.descricao"
                :options="comboTipoPagamento"
                placeholder="Selecione o tipo de pagamento para automação"
                data-cy="tipo-pagamento"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <!-- conta padrao -->
          <b-col cols="12">
            <b-form-group label="Conta Padrão" label-for="v-conta">
              <v-select
                v-model="regsitrationTypePlace.contaPadrao"
                :get-option-label="(opt) => opt.descricao || opt.nome"
                :options="comboContas"
                placeholder="Selecione a conta para automação"
                data-cy="conta"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <!-- forma pagamento padrao -->
          <b-col cols="12">
            <b-form-group
              label="Forma de Pagamento Padrão"
              label-for="v-forma-pagamento"
            >
              <v-select
                v-model="regsitrationTypePlace.formaPagamentoPadrao"
                :get-option-label="(opt) => opt.descricao"
                :options="comboFormasPagamento"
                placeholder="Selecione a forma de pagamento padrão"
                data-cy="forma-pagamento-padrao"
                :disabled="!canEditOrInsert"
              />
              <small class="text-muted"
                >Usada pela automação de cobranças. O associado pode ter uma
                preferência individual diferente.</small
              >
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="regsitrationTypePlace.validarCpfCnpj"
                :checked="regsitrationTypePlace.validarCpfCnpj"
                name="check-validar"
                switch
                inline
                :disabled="!canEditOrInsert"
              >
                Exigir CPF/CNPJ Obrigatório?
              </b-form-checkbox>
              <small class="text-muted d-block mt-25"
                >Se desativado, o CPF/CNPJ se torna opcional no momento do
                cadastro para este tipo de registro.</small
              >
            </b-form-group>
          </b-col>

          <b-col v-if="regsitrationTypePlace.id" cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="regsitrationTypePlace.validarCpfCnpj"
                :checked="regsitrationTypePlace.validarCpfCnpj"
                name="check-validar"
                switch
                inline
                :disabled="!canEditOrInsert"
              >
                {{ regsitrationTypePlace.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import { verificarPermissao } from "@/auth/utils";

import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("registrationTypeSettingsModule", {
      registrationType: (state) => state.registrationType,
      comboTypes: (state) => state.comboTypes,
      comboTipoFaixa: (state) => state.comboTipoFaixa,
      comboTipoPagamento: (state) => state.comboTipoPagamento,
      comboContas: (state) => state.comboContas,
      comboFormasPagamento: (state) => state.comboFormasPagamento,
    }),
    canInsert() {
      return verificarPermissao('ROLE_TIPO_REGISTRO_INSERIR');
    },
    canEdit() {
      return verificarPermissao('ROLE_TIPO_REGISTRO_ATUALIZAR');
    },
    canEditOrInsert() {
      return (
        (!this.regsitrationTypePlace.id && this.canInsert) ||
        (this.regsitrationTypePlace.id && this.canEdit)
      );
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    Cleave,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: "Cadastro de Tipos de Registro",
      required,
      regsitrationTypePlace: {
        nome: "",
        ativo: true,
        validarCpfCnpj: true,
        tipo: null,
      },
      options: {
        number: {
          numeral: true,
          numeralDecimalMark: ",",
          delimiter: ".",
        },
      },
    };
  },
  mounted() {
    this.regsitrationTypePlace = JSON.parse(
      JSON.stringify(this.registrationType),
    );
    this.$store.dispatch("registrationTypeSettingsModule/loadComboType");
    this.$store.dispatch("registrationTypeSettingsModule/loadComboTipoFaixa");
    this.$store.dispatch(
      "registrationTypeSettingsModule/loadComboTipoPagamento",
    );
    this.$store.dispatch("registrationTypeSettingsModule/loadComboContas");
    this.$store.dispatch(
      "registrationTypeSettingsModule/loadComboFormasPagamento",
    );
  },
  methods: {
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch(
        "registrationTypeSettingsModule/resetRegistrationType",
      );
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.regsitrationTypePlace.id) {
            this.$store
              .dispatch(
                "registrationTypeSettingsModule/editRegistrationType",
                this.regsitrationTypePlace,
              )
              .then(() => {
                this.showMessageSuccess("Editar", "Editado com sucesso!");
                this.$refs.form.reset();
                this.cancel();
              })
              .catch((error) => {
                const errorMsg = this.getErrorMessage(error);
                this.MensagemError("Falha ao Editar", errorMsg);
              });
          } else {
            this.$store
              .dispatch(
                "registrationTypeSettingsModule/insertNewRegistrationType",
                this.regsitrationTypePlace,
              )
              .then(() => {
                this.showMessageSuccess("Salvo", "Incluido com sucesso!");
                this.cleanObjeto();
                this.$refs.form.reset();
              })
              .catch((error) => {
                const errorMsg = this.getErrorMessage(error);
                this.MensagemError("Falha ao Inserir", errorMsg);
              });
          }
        }
      });
    },
    cleanObjeto() {
      this.regsitrationTypePlace = {
        nome: "",
        ativo: true,
        validarCpfCnpj: true,
        tipo: null,
        tiposFaixaPadrao: [],
        tipoPagamentoPadrao: null,
        contaPadrao: null,
        formaPagamentoPadrao: null,
      };
    },
  },
};
</script>
